import UpdateInventoryContent from "../../content/inventory/updateInventory";
import { Layout } from "../../layout/page";

export function UpdatedInventoryInput() {
  return (
    <Layout>
      <UpdateInventoryContent />
    </Layout>
  );
}
